var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-select',{staticClass:"form-control-label",attrs:{"required":"","v-model":_vm.isSelected,"id":_vm.id,"options":_vm.products,"textlabel":_vm.textlabel},on:{"change":_vm.updateSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }